import styled from '@emotion/styled';

/**
 * Minimal Wrapper for the Nike AI panel
 *
 * The nike-ai-search MFE handles all its own styling, positioning, and animations internally.
 * This wrapper provides only a minimal z-index override.
 *
 * As of nike-ai-search v2.4.0+, the MFE includes:
 * - Desktop: Fixed right panel (393px × full height) with slide-in animations
 * - Mobile: Bottom sheet with expand/collapse behavior (controlled by MFE)
 * - TopBar component with built-in expand/collapse controls
 * - WelcomeScreen, GuestModal, and other UI features
 * - Event listeners for controller integration
 *
 * Changes from previous implementation:
 * - Removed duplicate desktop positioning overrides (top, right, dimensions)
 * - Removed duplicate slide-in animation (MFE handles this)
 * - Removed forced border-radius (MFE sets this correctly)
 * - Removed variant-B mobile override (MFE handles mobile collapse/expand)
 * - Minimal z-index override to ensure panel appears above nav elements
 */
export const PanelWrapper = styled.div`
  /* Minimal z-index override to ensure panel appears above navigation */
  & .mfe-nike-ai-search.expanded {
    z-index: 1001 !important;
  }
`;
